import { render, staticRenderFns } from "./IconHome.vue?vue&type=template&id=2ce86661&functional=true"
import script from "./IconHome.vue?vue&type=script&lang=js"
export * from "./IconHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports